import React, { useEffect, useRef, useState } from "react";
import { Play, Pause, RotateCcw } from "lucide-react";
import { Reveal } from "./Reveal";
import { TIMELINE, OLD_CONCLUSION } from "./data";

function minutesFrom(base, t) {
  const [bh, bm] = base.split(":").map(Number);
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m - (bh * 60 + bm);
}

export default function OldWorld() {
  const [revealed, setRevealed] = useState(1);
  const [playing, setPlaying] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    if (!playing) return;
    timer.current = setInterval(() => {
      setRevealed((r) => {
        if (r >= TIMELINE.length) {
          setPlaying(false);
          return r;
        }
        return r + 1;
      });
    }, 1500);
    return () => clearInterval(timer.current);
  }, [playing]);

  const done = revealed >= TIMELINE.length;
  const elapsed = minutesFrom("09:12", TIMELINE[revealed - 1].time);
  const stallPct = Math.min(100, (elapsed / 40) * 100);

  return (
    <section className="section section--old" id="old-world">
      <div className="wrap">
        <Reveal>
          <div className="sec-head">
            <span className="sec-kicker">The old world</span>
            <h2 className="sec-title">The decision nobody can move.</h2>
            <p className="sec-sub">
              The same exception, hour by hour. Watch where ordinary coordination quietly fails.
            </p>
          </div>
        </Reveal>

        <div className="old-controls" data-testid="old-controls">
          <button
            className="btn btn--accent btn--sm"
            data-testid="timeline-play"
            onClick={() => {
              if (done) setRevealed(1);
              setPlaying((p) => !p);
            }}
          >
            {playing ? <Pause size={16} /> : <Play size={16} />}
            {done ? "Replay timeline" : playing ? "Pause" : "Play timeline"}
          </button>
          <button
            className="btn btn--ghost btn--sm"
            data-testid="timeline-reset"
            onClick={() => { setPlaying(false); setRevealed(1); }}
          >
            <RotateCcw size={15} /> Reset
          </button>
          <div className="stall">
            <span className="stall__label">ELAPSED</span>
            <span className="stall__val" data-testid="stall-elapsed">
              {String(elapsed).padStart(2, "0")} MIN
            </span>
            <span className="stall__bar"><i style={{ width: stallPct + "%" }} /></span>
            <span className={"stall__state" + (done ? " is-bad" : "")}>
              {done ? "UNRESOLVED" : "STALLING"}
            </span>
          </div>
        </div>

        <ol className="timeline">
          {TIMELINE.map((m, i) => {
            const on = i < revealed;
            const active = i === revealed - 1;
            return (
              <li
                key={m.time}
                className={"tl" + (on ? " is-on" : "") + (active ? " is-active" : "")}
                data-testid={"timeline-item-" + i}
                onClick={() => { setPlaying(false); setRevealed(i + 1); }}
              >
                <span className="tl__time">{m.time}</span>
                <span className="tl__dot" />
                <div className="tl__body">
                  <p className="tl__event">{m.event}</p>
                  <p className="tl__fault">{m.fault}</p>
                </div>
              </li>
            );
          })}
        </ol>

        {done && (
          <Reveal>
            <div className="old-conclusion" data-testid="old-conclusion">
              {OLD_CONCLUSION}
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
